
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";

import CurrencyCell from "../../../component/CurrencyCell";

export default function WGRTotals({
  shop,
  totals,
}) {
  return (
    <TableContainer>
    <Table size="small">
      <TableBody>
        <TableRow
          sx={{
            bgcolor: "primary.light",
            "& td": {
              fontWeight: 700,
              borderTop: "2px solid",
              borderColor: "primary.main",
              whiteSpace: "nowrap",
              
            },
          }}
        >

         

          <TableCell align="left" >
           {shop}  Total
          </TableCell>


          <TableCell align="right"  >
            <CurrencyCell
              value={totals.dl}
            />
          </TableCell>

          <TableCell align="right"  >
            <CurrencyCell
              value={totals.ds}
            />
          </TableCell>

          <TableCell align="right">
            <CurrencyCell
              value={totals.ocl}
            />
          </TableCell>

          
 <TableCell align="right"  >
            <CurrencyCell
              value={totals.ocs}
            />
          </TableCell>

          <TableCell align="right"  >
            <CurrencyCell
              value={totals.total}
            />
          </TableCell>

         

        </TableRow>
      </TableBody>
    </Table>
    </TableContainer>
  );
}

